/** PURE_IMPORTS_START ._TimerObservable PURE_IMPORTS_END */
import { TimerObservable } from './TimerObservable';
export var timer = TimerObservable.create;
//# sourceMappingURL=timer.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/timer.js
// module id = ./node_modules/rxjs/_esm5/observable/timer.js
// module chunks = vendor